var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserWebStorageInstance } from '../user-web-storage';
import { ConntionInfo } from './ConnectionInfo';
import { CustomErrorClass, ErrorInformationStorage } from './ErrorInformationStorage';
import { ChangeValidityToTIFDict, Localization, Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from './properties/ResourcesManager';
let cachedLocaleKeys = null; // Cache for old keys during locale merge
/**
 * Merges localization dictionaries with optional overriding from BO.
 */
function mergeLocales(localeDict, overrideFromBO) {
    if (!localeDict)
        return;
    rollbackPreviousMerge(); // Handle cases with multiple connections and different locales
    for (const locale in localeDict) {
        const destinationDict = Localization[locale] || {};
        Localization[locale] = destinationDict;
        if (overrideFromBO) {
            cachedLocaleKeys = cachedLocaleKeys || {};
            cachedLocaleKeys[locale] = {};
        }
        const keys = localeDict[locale];
        for (const key in keys) {
            if (overrideFromBO) {
                cachedLocaleKeys[locale][key] = destinationDict[key];
            }
            destinationDict[key] = keys[key];
        }
    }
}
/**
 * Rolls back the previous localization merge.
 */
function rollbackPreviousMerge() {
    if (!cachedLocaleKeys)
        return;
    for (const locale in cachedLocaleKeys) {
        const oldKeys = cachedLocaleKeys[locale];
        for (const key in oldKeys) {
            const oldValue = oldKeys[key];
            if (oldValue === undefined) {
                delete Localization[locale][key];
            }
            else {
                Localization[locale][key] = oldValue;
            }
        }
    }
    cachedLocaleKeys = null;
}
/**
 * Updates localization for ChangeValidityToTIF.
 */
function updateChangeValidityToTIF() {
    for (const lang in ChangeValidityToTIFDict) {
        const dictLang = ChangeValidityToTIFDict[lang];
        const destinationDict = Localization[lang] || {};
        Localization[lang] = destinationDict;
        for (const key in dictLang) {
            destinationDict[key] = dictLang[key];
        }
    }
}
/**
 * Loads application resources, connections, and themes.
 */
export function ApplicationLoader() {
    return __awaiter(this, arguments, void 0, function* (conName = null) {
        try {
            Resources.setLocalizationWithoutBranding();
            if (!isNullOrUndefined(conName)) {
                const locales = yield UserWebStorageInstance.branding.locales(conName);
                mergeLocales(locales, conName !== null);
            }
        }
        catch (e) {
            ErrorInformationStorage.GetException(new CustomErrorClass('Locale loading error', 'ApplicationLoader', 'UserWebStorageInstance.branding.locales'));
        }
        try {
            if (!Resources.isHidden('ChangeValidityToTIF')) {
                updateChangeValidityToTIF();
            }
            Resources.setNeedForceUpdateLocale();
            ResourcesManager.InitStartLanguage();
        }
        catch (e) {
            ErrorInformationStorage.GetException(new CustomErrorClass('Locale initialization error', 'ApplicationLoader', 'updateChangeValidityToTIF'));
        }
        try {
            if (Resources.isTrue('property.allowGetIPFromServer')) {
                yield UserWebStorageInstance.applyIPAddress();
            }
        }
        catch (e) {
            ErrorInformationStorage.GetException(new CustomErrorClass('get-ip error', 'ApplicationLoader', 'UserWebStorageInstance.applyIPAddress'));
        }
        try {
            const connections = yield UserWebStorageInstance.connections.get();
            if (JSON.stringify(ConntionInfo.GetConnectionInfoArray()) !==
                JSON.stringify(connections.clientConnectionJsonArr)) {
                ConntionInfo.SetConnectionsInfo(connections.clientConnectionJsonArr);
                ConntionInfo.OnConnectionInfoArrayChanged.Raise();
            }
        }
        catch (e) {
            ErrorInformationStorage.GetException(new CustomErrorClass('Connection loading error', 'ApplicationLoader', 'UserWebStorageInstance.connections.get'));
            alert(Resources.getResource('panel.backoffice.You need to add connection!'));
        }
    });
}
/**
 * Loads the investing custom scheme for the specified connection.
 */
export function InvestingCustomSchemeLoader(conName) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield UserWebStorageInstance.branding.investingCustomScheme(conName);
    });
}
